import { HighlightableLetterData } from "./UIState";
import * as React from "react";
import { ChangeEvent } from "react";

export function Letter(props: {
    data: HighlightableLetterData;
    letterUpdater?: (value: string) => void;
    selected?: boolean;
}): React.JSX.Element {
    function modifyThisLetter(value: string) {
        props.letterUpdater(value);
    }

    function onBlankInput(e: ChangeEvent<HTMLInputElement>) {
        let value = e.target.value.toUpperCase();
        if (value.length > 1) {
            value = value[value.length - 1];
        } else if (value.length == 0) {
            modifyThisLetter(value);
            return;
        }

        // Now check that it's a letter
        let is_letter = value.match("[A-Z]") != null;
        if (is_letter) {
            modifyThisLetter(value);
        } else {
            // Cancel and do nothing
            e.preventDefault();
        }
    }

    let letterClassName = "letter";
    if (props.selected) {
        letterClassName += " selected-tile";
    }

    if (props.data.is_blank && props.data.ephemeral) {
        return (
            <div className={letterClassName}>
                <input
                    className="blank-input"
                    type="text"
                    onChange={onBlankInput}
                    value={props.data.text}
                />
                <div className="letter-points">{props.data.points}</div>
            </div>
        );
    } else {
        let textClassName = "text";
        if (props.data.is_blank) {
            // not ephemeral
            textClassName += " prev-blank";
        }
        if (props.data.highlight) {
            letterClassName += " highlight";
        }

        return (
            <div className={letterClassName}>
                <div className={textClassName}>{props.data.text}</div>
                <div className="letter-points">{props.data.points}</div>
            </div>
        );
    }
}
